import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class GeoPoint extends AbstractModel {
  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  static OnSerialized(instance: AbstractModel, json: any): void {
    super.OnSerialized(instance, json);
  }

  static OnDeserialized(instance: AbstractModel, json: any): void {
    super.OnDeserialized(instance, json);
  }
}
